import { useQueryHandler } from "@sinch/hooks/useQueryHandler";
import type { TagVisibility } from "@sinch/types/sinch.types";
import { find, pipe, prop, propEq } from "ramda";
import { useCallback } from "react";
import { TagVisibilities } from "@sinch/components/application/Tag/queries.graphql";
import { TagVisibilitiesQuery } from "@sinch/components/application/Tag/queries.types";

export const useTagVisibility = () => {
  const { data: tagsData, loading } = useQueryHandler<TagVisibilitiesQuery>(TagVisibilities);

  const getTagVisibilityLabel = useCallback(
    (visibility: TagVisibility) => pipe(find(propEq("id", visibility)), prop("label"))(tagsData?.tagVisibilities || []),
    [tagsData?.tagVisibilities]
  );

  const getOptionsList = () =>
    (tagsData?.tagVisibilities ?? []).map(({ id, label }) => ({
      value: id,
      label: label,
    }));

  return { getTagVisibilityLabel, getOptionsList, loading };
};
